import styled from 'styled-components';
import MenuButton from 'components/MenuButton';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';

export const StyledMenuButton = styled(MenuButton)`
  margin: 0.5rem;
`;

export const SubMenuWrapper = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  align-items: center;
  :hover {
    background: ${getColor('zircon')};
    cursor: pointer;
    p {
      color: ${getColor('dodgerBlue')} !important;
    }
  }
`;
